import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { BootstrapperBase } from '@trustedshops/tswp-core-common';
import {
  OnboardingService,
  TOKENS,
  UserflowOnboardingIds,
} from '@trustedshops/tswp-core-masterdata';
import { ENVIRONMENT, Environment } from '../models/environment.type';

@Injectable()
export class OnboardingBootstrapper implements BootstrapperBase {
  public constructor(
    @Inject(ENVIRONMENT) private readonly _environment: Environment,
    @Inject(TOKENS.OnboardingService)
    private readonly _onboardingService: OnboardingService
  ) {}
  //#endregion

  //#region Public Methods
  public async initialize(): Promise<void> {
    const {
      advancedPaidAccountChecklistId,
      paidAccountChecklistId,
      freeAccountChecklistId,
    } = this._environment.userFlow;
    const baseUrl = this._environment.userFlow.proxyApi;

    const onboardingIds: UserflowOnboardingIds = {
      advancedPaidAccountChecklistId,
      paidAccountChecklistId,
      freeAccountChecklistId,
    };
    this._onboardingService.initialize(onboardingIds, baseUrl);
  }
  //#endregion
}

export const OnboardingBootstrapperInitializer = [
  OnboardingBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: OnboardingBootstrapper) => {
      return () => initializer.initialize();
    },
    deps: [OnboardingBootstrapper],
  },
];
